<div class="reset-container">
  <mat-card class="reset-card">

    <div *ngIf="!token" class="token-invalid">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <h2>Невалиден линк</h2>
      <p>Линкот за ресетирање на лозинката е невалиден.</p>
      <button mat-raised-button color="primary" class="login-button" (click)="goToLogin()">
        Назад кон најава
      </button>
    </div>

    <form *ngIf="token" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <h2>Внесете нова лозинка</h2>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Нова лозинка</mat-label>
        <input matInput formControlName="newPassword" [type]="hideNew ? 'password' : 'text'" />
        <button mat-icon-button matSuffix type="button" (click)="hideNew = !hideNew">
          <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Потврди лозинка</mat-label>
        <input matInput formControlName="confirmPassword" [type]="hideConfirm ? 'password' : 'text'" />
        <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
          <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <button mat-raised-button color="primary" class="login-button" type="submit"
              [disabled]="isLoading">
        <span *ngIf="!isLoading">Потврди</span>
        <span *ngIf="isLoading">Промена...</span>
      </button>
    </form>

  </mat-card>
</div>
